module.exports = __webpack_public_path__ + "media/images/lb/911-5d4764d1ac9c12411fec3a4bff480773.svg";